import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { FormControl, FormHelperText, FormLabel } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { string } from 'yup'

import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { setAnswer } from 'redux/slices/SignupFormAnswers'
import { getErrorHelperText } from 'lib/participantProfile/Helper'

export const validateDropdownQuestion = async (
  answer: { id: string },
  question: QuestionsItems,
): Promise<string[]> => {
  let schema = string().nullable()
  if (question.required) {
    schema = schema.required()
  }

  try {
    await schema.validate(answer?.id)
    return []
  } catch (err: any) {
    return err.errors
  }
}

const DropdownQuestion = ({
  question,
  id,
  options,
  readOnlyMode,
  required,
}: DropdownQuestionProps) => {
  const { t } = useTranslation()

  const { answers, errors } = useAppSelector((state) => state.signupAnswers)

  const error = errors[id] || []
  const answer = answers[id]?.id || ''

  const dispatch = useAppDispatch()

  const handleChange = (event: SelectChangeEvent<any>) => {
    if (!readOnlyMode) {
      const answer = event.target.value
      dispatch(setAnswer({ questionId: id, answer: { id: answer } }))
    }
  }

  return (
    <FormControl
      required={required}
      variant="standard"
      fullWidth
      error={error.length > 0}
    >
      <FormLabel>{question}</FormLabel>
      <Select value={answer} onChange={handleChange}>
        {options.length > 0 ? (
          options.map((option: any) => {
            return (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            )
          })
        ) : (
          <MenuItem disabled data-testid="no-options">
            {t('participant.signUpQuestions.noOptions')}
          </MenuItem>
        )}
      </Select>
      <FormHelperText>{getErrorHelperText(error, question)}</FormHelperText>
    </FormControl>
  )
}

export default DropdownQuestion
